// Groups of tickers that refer to the same underlying asset on different
// exchanges. The first entry of a group is the canonical code.
// Keep in sync with asset_aliases in base/constants.js
export default [
    ['ton', 'gram'],
]
